<template>
    <div class="productordering">
        <!--banner-->
        <div class="banner outer">
        <div class="inside1490">
            <h1 class="banner_title">渠道管理系统
            <!-- <span class="banner_rpo">HR版</span> -->
            </h1>
            <p class="banner_txt">渠道管理系统可管理外部交付渠道，协同完成交付目标<br/> 支持企业自建发单平台，自定义设置发单平台内容，提<br/>升品牌影响力<br/> 可灵活配置渠道职位职位及设置接单方式，同时可发布<br/>招募信息，招募供应商</p>
        </div>
        </div>
         <!--图片文字排版1-->
         <div class="outer">
                <div class="inside1490 textimgbox">
                <img
                    class="fl"
                    style="width: 768px;height: 442px;margin-top: 122px;"
                    src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/ordering/qudao1.png"
                />
                <div class="fr">
                    <h2>专属发单平台</h2>
                    <p class="text_detail">内外部职位打通，一键完成发布职位<br/> 支持外部渠道报名，快速招募优质供应商<br/> 支持供应商一键接单，快速达成交付合作</p>
                </div>
                </div>
            </div>
      <!--清除浮动-->
      <div class="clear"></div>
       <!--文字图片排版2-->
       <div class="outer">
        <div class="inside1490 imgtextbox">
          <div class="fl">
            <h2 style="text-align: left">智能渠道管理</h2>
            <p class="text_detail">系统自动简历查重，规避争议<br/> 候选人交付状态实时查看，紧跟反馈<br/> 支持供需转换，可互为甲乙方</p>
          </div>
          <img
            class="fr"
            style="width: 768px;height: 442px;margin-top: 120px;"
            src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/ordering/qudao2.png"
          />
        </div>
      </div>
      <!--清除浮动-->
      <div class="clear"></div>
        <!--图片文字排版1-->
        <div class="outer">
        <div class="inside1490 textimgbox">
            <img
                class="fl"
                style="width: 768px;height: 442px;margin-top: 122px;"
                src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/ordering/qudao3.png"
            />
            <div class="fr">
                <h2>渠道数据分析</h2>
                <p class="text_detail">渠道交付数据实时同步，精准把握进度<br/> 招聘进度、转化数据漏斗直观查看<br/> 结算凭证线上化，对账更清晰</p>
            </div>
        </div>
            </div>
      <!--清除浮动-->
      <div class="clear"></div>
      <div class="security outer">
          <div class="inside1490 security_child">
            <div class="security_left"><img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/icon_customer_service%402x.png"/></div>
            <div class="security_right">
              <p class="p1">即刻开启数字化招聘人效提升之旅</p>
              <!-- <div class="security_center" @click="trial()">申请试用</div> -->
            </div>
           
          </div>
      </div>
       <!--申请试用组件-->
    <populone v-if="windowflags" :isshow="windowflags" :selectId="''" :he="true" @handleChange="changewindows" />
    </div>
</template>
<script>
  import populone from "@/components/views/popul/populone";
  export default {
    name: "productordering",
    data() {
        return{
            windowflags: false,
        }
    },
    components: {
        populone,
    },
    methods:{
      trial(){
        this.windowflags = true;
        },
        changewindows(value) {
         this.windowflags = value;
        },
    },
    metaInfo: {
        title: '易猎云渠道管理系统-易猎云旗下产品',
        meta: [
          {
            name: 'keywords',
            content: '渠道管理系统，发单系统，发单平台，RPO'
          },
          {
            name: 'description',
            content: '渠道管理系统可管理外部交付渠道，协同完成交付目标支持企业自建发单平台，自定义设置发单平台内容，提升品牌影响力可灵活配置渠道职位职位及设置接单方式，同时可发布招募信息，招募供应商'
          }
        ]
    },
}
</script>
<style lang="less" scoped>
@import "~@/assets/css/style/index.less";
.productordering{
    margin-top: 85px;
  .banner {
    width: 100%;
    height: 730px;
    background-image: url('https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/ordering/banner_channel%20management%402x.png');
    background-repeat: no-repeat;
    background-size: 100%;
    padding-top: 230px;
    box-sizing: border-box;
    .banner_title{
      font-size: 60px;
      color: #1D2754;
      line-height: 112px;
    }
    .banner_rpo{
        display: inline-block;
        width: 80px;
        height: 34px;
        border-radius: 7px;
        border: 1px solid #5666FF;
        font-size: 20px;
        color: #5666FF;
        line-height: 34px;
        text-align: center;
        vertical-align: top;
        margin-top: 30px;
      }
    .banner_txt{
      font-size: 24px;
      color: #3A4D70;
      line-height: 40px;
    }
  }
  .textimgbox {
      width: 1490px;
      height: 610px;
      border-bottom: solid 1px #E4E6EE;
      h2 {
        font-size: 42px;
        margin-top: 126px;
        font-weight: 500;
        color: #1d2754;
        line-height: 48px;
      }
      .text_detail{
        width: 453px;
        font-size: 24px;
        color: #7087A6;
        line-height: 42px;
        margin-top: 31px;
      }
    }
    .imgtextbox {
      width: 1490px;
      height: 610px;
      border-bottom: solid 1px #E4E6EE;
      h2 {
        font-size: 42px;
        margin-top: 120px;
        font-weight: 500;
        color: #1d2754;
        line-height: 48px;
      }
      .text_detail{
        width: 408px;
        font-size: 24px;
        color: #7087A6;
        line-height: 42px;
        margin-top: 31px;
      }
    }
    .clear {
      clear: both;
    }
    .security{
      width: 100%;
      height: 277px;
      background-image: url('https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/bg_01%402x.png');
      background-repeat: no-repeat;
      background-size: 100% 102%;
      padding-top: 53px;
      box-sizing: border-box;
      .security_child{
        display: flex;
        .security_left{
            margin-left: 197px;
              img{
                width: 145px;
                height: 128px;
              }
        }
        .security_right{
             margin-left: 37px;
              .p1{
              display: inline-block;
              font-size: 48px;
              font-weight: 500;
              color: #ffffff;
              text-align: left;
              margin-top: 47px;
          }
        }
        .security_center{
          width: 158px;
          height: 66px;
          background: #FFFFFF;
          border-radius: 7px;
          line-height: 66px;
          text-align: center;
          font-size: 24px;
          color: #215FFF;
          cursor: pointer;
          margin: 0 auto;
          margin-top: 40px;
        }
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/product/productordering.vue